import React from 'react';
import {Outlet, Navigate} from "react-router-dom";

function ProtectedRoutes() {
    return "1" !== 1 ? <Outlet/> : <Navigate to={'/*'} replace={true}/>;
}

export default ProtectedRoutes;